import { useEffect, useRef, useState } from "react";
import {
  AccountInfo,
  InteractionRequiredAuthError,
  InteractionStatus,
} from "@azure/msal-browser";
import { Avatar } from "primereact/avatar";
import defaultAvatar from "../../../assets/imgs/defaultAvatar.png";
import { Divider } from "primereact/divider";
import { useAccount, useMsal } from "@azure/msal-react";
import { Menu } from "primereact/menu";
import { getMe, getPhoto } from "../../../services/MsGraphApiCall";
import { FILTER_PROFILE } from "../../../diccionary/Diccionary";
import axios from "axios";
import { IUserAccess } from "../../../interfaces/ISeleccion";
import NavDropdown from "./NavDropdown";
import NavItem from "./NavItem";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

type PreveTopbarProps = {
  children?: JSX.Element | JSX.Element[];
  onToggleMenuClick: (event: React.MouseEvent) => void;
  active: string;
  itemMenu?: string;
  setItemMenu?: Function;
};

type GraphData = {
  displayName: string;
  givenName: string;
  jobTitle: string;
  mail: string;
  surname: string;
  userPrincipalName: string;
  id: string;
};

const authRequest = { scopes: ["User.Read"] };

const MASIVA_OPTIONS = [
  { label: "Procesos", to: "/procesos/activos", shared: true },
  {
    label: "Selección",
    to: "/seleccionmasiva/porvalidar",
    shared: false,
    activePaths: ["/seleccionmasiva"],
  },
];

const PROFESIONAL_OPTIONS = [
  { label: "Procesos", to: "/procesos/activos", shared: true },
  {
    label: "Selección",
    to: "/seleccionprofesional/porvalidar",
    shared: false,
    activePaths: ["/seleccionprofesional"],
  },
];

const PreveTopbar: React.FC<PreveTopbarProps> = () => {
  const { instance, inProgress } = useMsal();
  const accounts = useMsal().accounts;
  const account = useAccount(accounts[0] || {});
  const [profile, setProfile] = useState<string>("");
  const [graphData, setGraphData] = useState<GraphData | null>(null);
  const [photo, setPhoto] = useState<string | null>(null);
  const [itemMasivo, setItemMasivo] = useState<boolean[] | undefined>(undefined);
  const [itemProf, setItemProf] = useState<boolean[] | undefined>(undefined);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const usuarioId = window.sessionStorage.getItem("usuarioId") as string;
  const token = window.sessionStorage.getItem("token") as string;
  const menu = useRef<any>(null);

  useEffect(() => {
    const profileA = window.sessionStorage.getItem("profile") ?? "";
    setProfile(profileA);
  }, []);

  useEffect(() => {
    if (token && usuarioId) getUserAccess({ token });
  }, [token]);

  useEffect(() => {
    const acquireToken = () => {
      instance.acquireTokenRedirect({
        ...authRequest,
        account: instance.getActiveAccount() as AccountInfo,
      });
    };
    if (!graphData && inProgress === InteractionStatus.None) {
      getMe(instance)
        .then(setGraphData)
        .catch((e) => {
          if (e instanceof InteractionRequiredAuthError) acquireToken();
        });
      getPhoto(instance)
        .then(setPhoto)
        .catch((e) => {
          if (e instanceof InteractionRequiredAuthError) acquireToken();
        });
    }
  }, [instance, graphData, photo, inProgress]);

  const getUserAccess = async ({ token }: { token: string }) => {
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_API_URL}usuario/${usuarioId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = result.data.data;
      setItemMasivo(data.map(({ masivo }: IUserAccess) => masivo));
      setItemProf(data.map(({ profesional }: IUserAccess) => profesional));
    } catch (error) {
      console.error("[PreveTopbar] getUserAccess:", error);
    }
  };

  const handleLogout = () => {
    instance.logoutPopup({ mainWindowRedirectUri: "/" });
  };

  const userMenuItems = [
    { label: "Perfil", icon: "pi pi-fw pi-user", command: () => { } },
    { label: "Configuraciones", icon: "pi pi-fw pi-cog" },
    { separator: true },
    { label: "Salir", icon: "pi pi-fw pi-power-off", command: handleLogout },
  ];

  const logoHref = (() => {
    if (profile === FILTER_PROFILE.tw_legal) return "/consultaexclusionrut";
    if (profile === FILTER_PROFILE.tw_cliente) return "/validacioncliente";
    if (profile === FILTER_PROFILE.admin_ops) return "/resumen";
    if (profile === FILTER_PROFILE.tw_ops || profile === FILTER_PROFILE.tw_contrato) return "/postulaciones?tab=formularios";
    return "/consultaexclusionrut";
  })();

  const profileIn = (...values: string[]) => values.includes(profile);

  const showIngresoRut =
    profile &&
    profileIn(
      FILTER_PROFILE.tw_admsel_prof,
      FILTER_PROFILE.tw_admsel,
      FILTER_PROFILE.tw_legal,
      FILTER_PROFILE.adm_tw, FILTER_PROFILE.adm_ti
    );

  const showMasiva =
    profile &&
    (profileIn(FILTER_PROFILE.adm_tw, FILTER_PROFILE.adm_ti, FILTER_PROFILE.tw_admsel, FILTER_PROFILE.admin_sel) ||
      (profile === FILTER_PROFILE.tw_sel && itemMasivo?.includes(true)));

  const showProfesional =
    profile &&
    (profileIn(FILTER_PROFILE.adm_tw, FILTER_PROFILE.adm_ti, FILTER_PROFILE.tw_admsel_prof, FILTER_PROFILE.admin_sel) ||
      (profile === FILTER_PROFILE.tw_sel && itemProf?.includes(true)));

  const showRegistros = profile && (showMasiva || showProfesional || profile === FILTER_PROFILE.tw_sel);

  return (
    <>
      <header className="prevetopbar stickyFunction2">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 24px",
            height: "64px",
          }}
        >
          {/* Logo */}
          <a href={logoHref} style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
            <img
              src="/assets/layout/images/logo-teamwork-chile.png"
              alt="TeamWork"
              style={{ width: "169px", height: "33px", border: 0 }}
            />
          </a>

          {/* Desktop nav */}
          <nav className="topbar-nav"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "28px",
              height: "64px",
              flex: 1,
              paddingLeft: "40px",
            }}
          >
            {showRegistros && (
              <NavItem
                label="Registros"
                to="/registros/habilitados"
                activePaths={["/registros"]}
              />
            )}

            {showMasiva && (
              <NavDropdown
                label="Selección Masiva"
                selectionType="masivo"
                options={MASIVA_OPTIONS}
              />
            )}

            {showProfesional && (
              <NavDropdown
                label="Selección Profesional"
                selectionType="profesional"
                options={PROFESIONAL_OPTIONS}
              />
            )}
          </nav>

          {/* User area + hamburger */}
          <div style={{ display: "flex", alignItems: "center", gap: "12px", flexShrink: 0 }}>
            {account?.name && (
              <span
                className="topbar-username"
                style={{
                  fontFamily: "Roboto, sans-serif",
                  fontSize: "14px",
                  color: "#48566b",
                  maxWidth: "180px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {account.name}
              </span>
            )}
            <button
              className="p-link layout-topbar-button"
              onClick={(e) => menu.current.toggle(e)}
              style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
            >
              <Avatar image={photo || defaultAvatar} size="large" shape="circle" />
            </button>
            <Menu model={userMenuItems} popup ref={menu} id="preve_topbar_menu" />

            {/* Hamburger — hidden on desktop, shown on mobile via CSS */}
            <button
              className="topbar-hamburger"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Menú"
            >
              {mobileMenuOpen
                ? <CloseIcon style={{ fontSize: 26, color: "#333" }} />
                : <MenuIcon style={{ fontSize: 26, color: "#333" }} />
              }
            </button>
          </div>
        </div>

        {/* Mobile dropdown */}
        {mobileMenuOpen && (
          <nav className="topbar-mobile-menu">
            {showRegistros && (
              <NavItem
                label="Registros"
                to="/registros/habilitados"
                activePaths={["/registros"]}
              />
            )}
            {showMasiva && (
              <NavDropdown
                label="Selección Masiva"
                selectionType="masivo"
                options={MASIVA_OPTIONS}
                inlinePanel
              />
            )}
            {showProfesional && (
              <NavDropdown
                label="Selección Profesional"
                selectionType="profesional"
                options={PROFESIONAL_OPTIONS}
                inlinePanel
              />
            )}
          </nav>
        )}

        <Divider type="dashed" style={{ margin: 0 }} />
      </header>
    </>
  );
};

export default PreveTopbar;
